import { motion } from "framer-motion";
import { Check, Timer, RefreshCw } from "lucide-react";
import useCountdown from "../../hooks/useCountdown";
import { CAPCUT } from "../../config";

const buy = () => {
  window.location.href = CAPCUT.checkoutUrl;
};

const perks = [
  "Durasi 1 bulan penuh",
  "Akses 1 perangkat (HP / Laptop / PC)",
  "Semua fitur Pro terbuka",
  "Ekspor tanpa watermark hingga 4K",
  "Akun dari penjual — tinggal login",
  "Proses instan, dikirim via WhatsApp",
];

export const CapCutPricing = () => {
  const { h, m, s } = useCountdown();

  return (
    <section className="py-24 bg-[#F8FAFC]" id="capcut-harga">
      <div className="max-w-xl mx-auto px-6 sm:px-8">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-capcut-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900 text-center mb-12"
        >
          Sekali bayar, sebulan <span className="text-blue-600">bebas edit</span>.
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 30, scale: 0.98 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="rounded-2xl bg-white border border-slate-200 shadow-[0_20px_60px_rgb(15,23,42,0.08)] overflow-hidden"
          data-testid="capcut-pricing-card"
        >
          <div className="h-1.5 bg-gradient-to-r from-blue-600 to-cyan-400" />
          <div className="p-6 sm:p-8">
            <div className="rounded-xl bg-blue-600 text-white px-4 py-3.5 flex items-center justify-between gap-3 flex-wrap" data-testid="capcut-countdown">
              <span className="flex items-center gap-2 text-sm font-bold">
                <Timer className="w-4 h-4" /> Promo berakhir dalam
              </span>
              <span className="flex items-center gap-1.5">
                {[{ v: h, l: "Jam" }, { v: m, l: "Mnt" }, { v: s, l: "Dtk" }].map((t, i) => (
                  <span key={t.l} className="flex items-center gap-1.5">
                    <span className="flex flex-col items-center rounded-lg bg-white/15 px-2 py-1">
                      <span className="font-capcut-heading font-black text-base leading-none tabular-nums">{t.v}</span>
                      <span className="text-[8px] font-bold uppercase tracking-wider">{t.l}</span>
                    </span>
                    {i < 2 && <span className="font-bold">:</span>}
                  </span>
                ))}
              </span>
            </div>

            <div className="flex items-center justify-between mt-7">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-blue-600">CapCut Pro — 1 Bulan</p>
              <span className="rounded-full bg-blue-600 text-white text-[10px] font-bold px-3 py-1 uppercase tracking-wide">Best Deal</span>
            </div>

            <p className="mt-2 font-capcut-heading">
              <span className="text-5xl sm:text-6xl font-black text-slate-900" data-testid="capcut-pricing-price">{CAPCUT.pricePromoLabel}</span>
              <span className="text-slate-400 font-semibold text-lg ml-2">/ bulan</span>
            </p>

            <ul className="mt-6 space-y-3">
              {perks.map((perk) => (
                <li key={perk} className="flex items-center gap-3 text-sm font-medium text-slate-700">
                  <span className="w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
                    <Check className="w-3 h-3 text-emerald-600" strokeWidth={3} />
                  </span>
                  {perk}
                </li>
              ))}
            </ul>

            <motion.button
              whileHover={{ scale: 1.02, y: -2 }}
              whileTap={{ scale: 0.97 }}
              onClick={buy}
              data-testid="capcut-pricing-cta"
              className="mt-8 w-full rounded-full bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg py-4 shadow-[0_4px_14px_0_rgb(37,99,235,0.39)] hover:shadow-[0_10px_30px_rgba(37,99,235,0.4)] transition-[box-shadow,background-color] duration-300"
            >
              BELI SEKARANG
            </motion.button>
            <p className="mt-3 text-center text-xs text-slate-400">Pembayaran diarahkan ke halaman checkout yang aman.</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mt-6 rounded-2xl bg-cyan-50 border border-cyan-200 p-5 flex gap-3"
          data-testid="capcut-sync-note"
        >
          <span className="w-9 h-9 rounded-xl bg-white border border-cyan-200 flex items-center justify-center shrink-0">
            <RefreshCw className="w-4 h-4 text-cyan-600" strokeWidth={2.2} />
          </span>
          <p className="text-sm text-slate-700 leading-relaxed">
            <span className="font-bold text-slate-900">Project & editanmu aman.</span> Semua project dapat muncul kembali sesuai sistem
            sinkronisasi CapCut, jadi kamu nggak perlu khawatir kehilangan hasil kerja.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
